/**
 * Contexto global de autenticación.
 *
 * Expone:
 * - `currentUser` con el usuario autenticado de Firebase Auth,
 * - `logout` para cerrar sesión,
 * - y retrasa el render hasta conocer el estado inicial de auth.
 */
import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Sincroniza React con el estado real de sesión de Firebase.
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const logout = () => {
    return signOut(auth)
      .then(() => {
        setCurrentUser(null);
      })
      .catch((error) => {
        console.error("Error al cerrar sesión: ", error);
      });
  };

  const value = { currentUser, logout };

  return (
    <AuthContext.Provider value={value}>
      {/* Evita renderizados prematuros de rutas protegidas. */}
      {!loading && children}
    </AuthContext.Provider>
  );
};
